import { isEmpty, get, includes } from 'lodash';

import { ColumnCustomFilterFunction } from './column-filter.types';

export const columnIncludeFilter: ColumnCustomFilterFunction = (params) => {
  const filters = get(params, ['filterModel', 'filter'], []) as Array<string>;

  if (isEmpty(filters)) {
    return true;
  }

  return includes(filters, params.cellValue);
};
